/* istanbul ignore file: Directive */
'use strict';

/**
 * Check if two passwords match
 * Only check match if the field is filled in.  If the field is required, use ngRequired.
 */
customerZone.directive('pwCheck', [function () {
    return {
        require: 'ngModel',
        link: function (scope, elem, attrs, ctrl) {
            var $other = $('#'+attrs.pwCheck);
            ctrl.$validators.pwmatch = function(modelValue, fieldValue){
                if (!fieldValue || fieldValue === '') return true;
                var firstValue = $other.val();
                if (!firstValue || firstValue === '') return true;
                return fieldValue===firstValue;
            };
            $other.on('keyup', function(){
                scope.$apply(function(){
                    ctrl.$validate();
                });
            });
        }
    };
}]);
